import { Term } from "Interfaces/BookResort";
import { OwnerInfoRecord } from "Interfaces/OwnerInfo";
import ReservationService from "Services/reservation.service";
import { Actions, TransferPointAction, TransferPointsState, SelectedContract, Contract, PageErrorType, PageErrors, ReciepientInformation, inputErrors, ReipientInformationErrors } from "./types";

const reservationService: ReservationService = new ReservationService();
// const localizationService: LocalizationService = new LocalizationService();

const InitPageErrors: PageErrors = {
    [PageErrorType.lastContractEmpty]: {
        message: 'Please enter details for the previous contract, before attempting to add a new contract',
        isErrored: false
    },
    [PageErrorType.apiError]: {
        message: 'Sorry, something went wrong, please try again later or please contact Owner/Member Services',
        isErrored: false,
    },
    [PageErrorType.duplicateContract]: {
        message: 'Contract id, year and type already selected',
        isErrored: false,
    },
    [PageErrorType.emailError]: {
        message: 'Please enter a valid email address',
        isErrored: false,
    },
    [PageErrorType.apiSubmitError]: {
        message: 'Sorry, we are not able to process the request at this time, please try again',
        isErrored: false,
    },
};

const RecipientErrors: ReipientInformationErrors = {
    [PageErrorType.reipientFirstNameInputError]: {
        message: 'Recipient owner first name cannot be empty',
        isErrored: false
    },
    [PageErrorType.reipientLastNameInputError]: {
        message: 'Recipient owner last name cannot be empty',
        isErrored: false,
    },
    [PageErrorType.reipientOwnerNumberInputError]: {
        message: 'Recipient owner number cannot be empty',
        isErrored: false,
    },
    [PageErrorType.reipientContractIdInputError]: {
        message: 'Recipient contract id cannot be empty',
        isErrored: false,
    },
    [PageErrorType.termsError]: {
        message: '',
        isErrored: false,
    },
    [PageErrorType.additionalEmailError]: {
        message: 'Email field must be valid and cannot be empty',
        isErrored: false,
    },
    [PageErrorType.selectedContractsEmpty]: {
        message: 'Please enter atleast one contract for transfer',
        isErrored: false,
    },
    
    [PageErrorType.transferPointError]: {
        message: 'Sorry, We cannot transfer more than 20,000 points per usage year, please try again',
        isErrored: false,
    },
    [PageErrorType.contractsPageError]: {
        message: 'Please correct the errors in the contracts section',
        isErrored: false,
    },
    [PageErrorType.twentyThousandPerUsageYearError]: {
        message: 'Please select less than 20,000 points per usage year',
        isErrored: false,
    },
    [PageErrorType.availablePointsPerContractError]: {
        message: 'You have entered more than available points for selected contract',
        isErrored: false,
    },
};

const InitOwnerInfo: OwnerInfoRecord = {
    cieId: 0,
    ownerNumber: "",
    firstName: "",
    middleName: "",
    lastName: "",
    sourceSystem: "",
    memberships: [],
    ownerBenefitLevels: [],
    email: "",
    phone: {
        code: "",
        phoneNumber: ""
    }
};

const InitRecipientInformation: ReciepientInformation = {
    firstName: "",
    lastName: "",
    ownerNumber: "",
    contractId: ""
}

const InitState: TransferPointsState = {
    contracts: [],
    ownerInfo: InitOwnerInfo,
    isloading: true,
    pageErrors: InitPageErrors,
    selectedContracts: [],
    recipientInformation: InitRecipientInformation,
    additionalEmail: "",
    terms: [],
    recipientErrors: RecipientErrors,
}

export const TransferPointsReducer = (state: TransferPointsState, action: TransferPointAction): TransferPointsState => {
    const { type, payload } = action;

    switch (type) {
        case Actions.SETDATA:
            const inputErrorsForEntry: inputErrors = {
                [PageErrorType.contractIdInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false
                },
                [PageErrorType.usageYearInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false,
                },
                [PageErrorType.usageTypeInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false,
                },
                [PageErrorType.pointsInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false,
                },
                [PageErrorType.twentyThousandError]: {
                    message: 'Please enter less than 20000 points',
                    isErrored: false
                },
                [PageErrorType.pointLimitError]: {
                    message: 'Please enter less than the points remaining',
                    isErrored: false
                },
                [PageErrorType.pointsError]: {
                    message: 'Please enter points in increments of 5',
                    isErrored: false
                },
                [PageErrorType.zeroPoints]: {
                    message: 'sorry, not enough points',
                    isErrored: false
                },
                [PageErrorType.noUsageTypePoints]: {
                    message: 'There are no available points to transfer',
                    isErrored: false
                }
            };

            const selectedcontract: SelectedContract = {
                contractId: "",
                usageYear: 0,
                usageType: "",
                numberofPointsToTransfer: 0,
                inputErrors: inputErrorsForEntry
            };

            return {
                ...state,
                ownerInfo: payload.ownerInfo ? payload.ownerInfo : InitOwnerInfo,
                contracts: payload.contracts,
                isloading: false,
                selectedContracts: [selectedcontract],
                terms: payload.terms
            };

        case Actions.ERROR:
            if(payload.PageErrorType === PageErrorType.apiError) {
                return {
                    ...state,
                    isloading: false,
                    pageErrors: {
                        ...state.pageErrors,
                        [PageErrorType.apiError]: { ...state.pageErrors.apiError, isErrored: true, message: payload.msg }
                    }
                };
            } else if(payload.PageErrorType === PageErrorType.apiSubmitError) {
                return {
                    ...state,
                    isloading: false,
                    pageErrors: {
                        ...state.pageErrors,
                        [PageErrorType.apiSubmitError]: { ...state.pageErrors.apiError, isErrored: true, message: payload.msg }
                    }
                };
            } 

        case Actions.ADDINPUTERROR:
            let chosenContracts: SelectedContract[] = JSON.parse(JSON.stringify(state.selectedContracts)); //[...state.selectedContracts];
            let lastContract: SelectedContract = chosenContracts.pop()!;

            switch(payload.key) {
                case "contractId":
                    lastContract.inputErrors[PageErrorType.contractIdInputError].isErrored = true;
                    // lastContract.inputErrors[PageErrorType.contractIdInputError].message = payload.errs.contractIdInputError;
                    break;
                    
                case "usageYear":
                    lastContract.inputErrors[PageErrorType.usageYearInputError].isErrored = true;
                    // lastContract.inputErrors[PageErrorType.usageYearInputError].message = payload.errs.usageYearInputError;
                    break;
                    
                case "usageType":
                    lastContract.inputErrors[PageErrorType.usageTypeInputError].isErrored = true;
                    // lastContract.inputErrors[PageErrorType.usageTypeInputError].message = payload.errs.usageTypeInputError;
                    break;

                case "numberofPointsToTransfer":
                    lastContract.inputErrors[PageErrorType.pointsInputError].isErrored = true;
                    // lastContract.inputErrors[PageErrorType.pointsInputError].message = payload.errs.pointsInputError;
                    break;
            }

            chosenContracts.push(lastContract);

            return {
                ...state,
                selectedContracts: chosenContracts
            }

        case Actions.TOGGLERECIPIENTINFOERROR:
            let recipientInformationErrors: ReipientInformationErrors = JSON.parse(JSON.stringify(state.recipientErrors));

            let validationsMap: Map<String, Boolean> = payload.validationsMap;

            validationsMap.forEach((value:Boolean, key: String) => {
                if(value) {
                    if(key === "firstNameEntry") {
                        recipientInformationErrors[PageErrorType.reipientFirstNameInputError].isErrored = true;
                        recipientInformationErrors[PageErrorType.reipientFirstNameInputError].message = payload.errs.reipientFirstNameInputError;
                    } else if(key === "lastNameEntry") {
                        recipientInformationErrors[PageErrorType.reipientLastNameInputError].isErrored = true;
                        recipientInformationErrors[PageErrorType.reipientLastNameInputError].message = payload.errs.reipientLastNameInputError;
                    } else if(key === "ownerNumber") {
                        recipientInformationErrors[PageErrorType.reipientOwnerNumberInputError].isErrored = true;
                        recipientInformationErrors[PageErrorType.reipientOwnerNumberInputError].message = payload.errs.reipientOwnerNumberInputError;
                    } else if(key === "ownerContractId") {
                        recipientInformationErrors[PageErrorType.reipientContractIdInputError].isErrored = true;
                        recipientInformationErrors[PageErrorType.reipientContractIdInputError].message = payload.errs.reipientContractIdInputError;
                    } else if(key === "terms") {
                        recipientInformationErrors[PageErrorType.termsError].isErrored = true;
                        recipientInformationErrors[PageErrorType.termsError].message = payload.errs.termsError;
                    } else if(key === "additionalEmail") {
                        recipientInformationErrors[PageErrorType.additionalEmailError].isErrored = true;
                        recipientInformationErrors[PageErrorType.additionalEmailError].message = payload.errs.additionalEmailError;
                    } else if(key === "validSelectedContracts") {
                        //To indicate contracts section is empty or if data is incomplete
                        recipientInformationErrors[PageErrorType.selectedContractsEmpty].isErrored = true;
                        recipientInformationErrors[PageErrorType.selectedContractsEmpty].message = payload.errs.selectedContractsEmpty;
                    } else if(key === "contractsWithError") {
                        //To indicate the contracts section have errors
                        recipientInformationErrors[PageErrorType.contractsPageError].isErrored = true;
                        recipientInformationErrors[PageErrorType.contractsPageError].message = payload.errs.contractsPageError;
                    } else if(key === "twentyThousandPerUsageYearError") {
                        //To indicate user has selected more than 20,000 points per usage year
                        recipientInformationErrors[PageErrorType.twentyThousandPerUsageYearError].isErrored = true;
                        recipientInformationErrors[PageErrorType.twentyThousandPerUsageYearError].message = payload.errs.twentyThousandPerUsageYearError;
                    }else if(key === "availablePointsPerContractError") {
                        //To indicate user has selected more than 20,000 points per usage year
                        recipientInformationErrors[PageErrorType.availablePointsPerContractError].isErrored = true;
                        recipientInformationErrors[PageErrorType.availablePointsPerContractError].message = payload.errs.availablePointsPerContractError;
                    }
                    // else if(key === "transferPointsError") {
                    //     recipientInformationErrors[PageErrorType.transferPointError].isErrored = true;
                    // }
                }
            });

            return {
                ...state,
                recipientErrors: recipientInformationErrors
            }


        case Actions.TOGGLEMODAL:
            return {
                ...state,
                pageErrors: {
                    ...state.pageErrors,
                    [PageErrorType.apiSubmitError]: {...state.pageErrors.apiSubmitError, isErrored: !state.pageErrors.apiSubmitError.isErrored}
                }
            }

        case Actions.ADDEMPTYCONTRACT:
            const inputErrorsForEntryEmpty: inputErrors = {
                [PageErrorType.contractIdInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false
                },
                [PageErrorType.usageYearInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false,
                },
                [PageErrorType.usageTypeInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false,
                },
                [PageErrorType.pointsInputError]: {
                    message: 'Please enter details for the previous contract, before attempting to add a new contract',
                    isErrored: false,
                },
                [PageErrorType.twentyThousandError]: {
                    message: 'Please enter less than 20000 points',
                    isErrored: false
                },
                [PageErrorType.pointLimitError]: {
                    message: 'Please enter less than the points remaining',
                    isErrored: false
                },
                [PageErrorType.pointsError]: {
                    message: 'Please enter points in increments of 5',
                    isErrored: false
                },
                [PageErrorType.zeroPoints]: {
                    message: 'sorry, not enough points',
                    isErrored: false
                },
                [PageErrorType.noUsageTypePoints]: {
                    message: 'There are no available points to transfer',
                    isErrored: false
                }
            };

            const newContract: SelectedContract = {
                contractId: "",
                usageYear: 0,
                usageType: "",
                numberofPointsToTransfer: 0,
                inputErrors: inputErrorsForEntryEmpty
            };

            let selectedContracts: SelectedContract[] = [...state.selectedContracts];
            selectedContracts.push(newContract);

            return {
                ...state,
                selectedContracts: selectedContracts
            };

        case Actions.ADDCONTRACTWITHDATA:
            let selectedContractsWithData: SelectedContract[] = [...state.selectedContracts];

            let lastContractFromStateArray: any = selectedContractsWithData[payload.key];

            if (!lastContractFromStateArray || Object.values(lastContractFromStateArray).some(x => x === null || x === '' || x === 0)) {
                //User is adding data to an incomplete box or updating a box
                lastContractFromStateArray.contractId = payload.contract.contractId;
                lastContractFromStateArray.numberofPointsToTransfer = payload.contract.numberofPointsToTransfer;
                lastContractFromStateArray.usageType = payload.contract.usageType;
                lastContractFromStateArray.usageYear = payload.contract.usageYear;

                if(payload.contract.contractId && payload.contract.contractId !== "" && payload.contract.inputErrors[PageErrorType.contractIdInputError].isErrored) {
                    lastContractFromStateArray.inputErrors[PageErrorType.contractIdInputError].isErrored = false;
                }

                if(payload.contract.usageYear && payload.contract.usageYear !== 0 && payload.contract.inputErrors[PageErrorType.usageYearInputError].isErrored) {
                    lastContractFromStateArray.inputErrors[PageErrorType.usageYearInputError].isErrored = false;
                }

                if(payload.contract.usageType && payload.contract.usageType !== "" && payload.contract.inputErrors[PageErrorType.usageTypeInputError].isErrored) {
                    lastContractFromStateArray.inputErrors[PageErrorType.usageTypeInputError].isErrored = false;
                }

                if(payload.contract.numberofPointsToTransfer && payload.contract.numberofPointsToTransfer !== 0 && payload.contract.inputErrors[PageErrorType.pointsInputError].isErrored) {
                    lastContractFromStateArray.inputErrors[PageErrorType.pointsInputError].isErrored = false;
                }

                selectedContractsWithData[payload.key] = lastContractFromStateArray;

                return {
                    ...state,
                    selectedContracts: selectedContractsWithData
                };
            } else {
                lastContractFromStateArray.contractId = payload.contract.contractId;
                lastContractFromStateArray.numberofPointsToTransfer = payload.contract.numberofPointsToTransfer;
                lastContractFromStateArray.usageType = payload.contract.usageType;
                lastContractFromStateArray.usageYear = payload.contract.usageYear;

                // lastContractFromStateArray.inputErrors[PageErrorType.contractIdInputError].isErrored = false;
                // lastContractFromStateArray.inputErrors[PageErrorType.usageTypeInputError].isErrored = false;
                // lastContractFromStateArray.inputErrors[PageErrorType.usageYearInputError].isErrored = false;
                // lastContractFromStateArray.inputErrors[PageErrorType.pointsInputError].isErrored = false;

                lastContractFromStateArray.inputErrors[PageErrorType.contractIdInputError].isErrored = payload.contract.inputErrors[PageErrorType.contractIdInputError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.usageTypeInputError].isErrored = payload.contract.inputErrors[PageErrorType.usageTypeInputError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.usageYearInputError].isErrored = payload.contract.inputErrors[PageErrorType.usageYearInputError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.pointsInputError].isErrored = payload.contract.inputErrors[PageErrorType.pointsInputError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.twentyThousandError].isErrored = payload.contract.inputErrors[PageErrorType.twentyThousandError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.pointLimitError].isErrored = payload.contract.inputErrors[PageErrorType.pointLimitError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.pointsError].isErrored = payload.contract.inputErrors[PageErrorType.pointsError].isErrored;
                lastContractFromStateArray.inputErrors[PageErrorType.noUsageTypePoints].isErrored = payload.contract.inputErrors[PageErrorType.noUsageTypePoints].isErrored;

                selectedContractsWithData[payload.key] = lastContractFromStateArray;

                if(state.recipientErrors.selectedContractsEmpty.isErrored) {
                    return {
                        ...state,
                        recipientErrors: {
                            ...state.recipientErrors,
                            [PageErrorType.selectedContractsEmpty]: {...state.recipientErrors[PageErrorType.selectedContractsEmpty], isErrored: false}
                        },
                        selectedContracts: selectedContractsWithData
                    }
                }

                if(state.recipientErrors.twentyThousandPerUsageYearError.isErrored) {
                    const usageYearData = {} as any;
                    selectedContractsWithData.forEach((contractItem: SelectedContract) => {
                        if (usageYearData[contractItem.usageYear]) {
                            usageYearData[contractItem.usageYear] += contractItem.numberofPointsToTransfer;
                        } else {
                            usageYearData[contractItem.usageYear] = contractItem.numberofPointsToTransfer;
                        }
                    });

                    let valid = true;
                    for (const year in usageYearData) {
                        const perYearTotalData = usageYearData[year];
                        if (perYearTotalData > 20000) {
                            valid = false;
                        }
                    }

                    if(valid) {
                        return {
                            ...state,
                            recipientErrors: {
                                ...state.recipientErrors,
                                [PageErrorType.twentyThousandPerUsageYearError]: {...state.recipientErrors[PageErrorType.twentyThousandPerUsageYearError], isErrored: false}
                            },
                            selectedContracts: selectedContractsWithData
                        }
                    }
                }

                if(state.recipientErrors.availablePointsPerContractError.isErrored) {
                    console.log('I am error')
                }

                // if(state.re)


                return {
                    ...state,
                    selectedContracts: selectedContractsWithData
                };
            }

        case Actions.ADDRECIPIENTDATA:
            const newReciepientInformation: ReciepientInformation = {
                ...state.recipientInformation,
                [payload.fieldName]: payload.value,
            };

            let recipientInformationErrorsAddData: ReipientInformationErrors = JSON.parse(JSON.stringify(state.recipientErrors));

            if(payload.fieldName === "firstName") {
                if(state.recipientErrors[PageErrorType.reipientFirstNameInputError].isErrored) {
                    recipientInformationErrorsAddData[PageErrorType.reipientFirstNameInputError].isErrored = false;
                } 
            } else if(payload.fieldName === "lastName") {
                if(state.recipientErrors[PageErrorType.reipientLastNameInputError].isErrored) {
                    recipientInformationErrorsAddData[PageErrorType.reipientLastNameInputError].isErrored = false;
                }
            } else if(payload.fieldName === "ownerNumber") {
                if(state.recipientErrors[PageErrorType.reipientOwnerNumberInputError].isErrored) {
                    recipientInformationErrorsAddData[PageErrorType.reipientOwnerNumberInputError].isErrored = false;
                }
            } else if(payload.fieldName === "contractId") {
                if(state.recipientErrors[PageErrorType.reipientContractIdInputError].isErrored) {
                    recipientInformationErrorsAddData[PageErrorType.reipientContractIdInputError].isErrored = false;
                }
            }

            return {
                ...state,
                recipientInformation: newReciepientInformation,
                recipientErrors: recipientInformationErrorsAddData
            }

        case Actions.ADDEMAIL:
            if(payload.isErrorEmail) {
                return {
                    ...state,
                    recipientErrors: {
                        ...state.recipientErrors,
                        [PageErrorType.additionalEmailError]: {...state.recipientErrors.additionalEmailError, isErrored: true, message: payload.err}
                    }
                }
            }

            const email: string = payload.email;

            if(state.recipientErrors[PageErrorType.additionalEmailError].isErrored) {
                return {
                    ...state,
                    ownerInfo: {
                        ...state.ownerInfo,
                        email: email,
                    },
                    recipientErrors: {
                        ...state.recipientErrors,
                        [PageErrorType.additionalEmailError]: {...state.recipientErrors.additionalEmailError, isErrored: false}
                    }
                }
            } else {
                return {
                    ...state,
                    ownerInfo: {
                        ...state.ownerInfo,
                        email: email,
                    }
                }
            }

        case Actions.DELETECONTRACT:
            let contracts: SelectedContract[] = JSON.parse(JSON.stringify(state.selectedContracts));

            let filteredContracts: SelectedContract[] = contracts.filter((contract: SelectedContract, index: number) => {
                    return index !== payload.key;
            });

            // const contracts: SelectedContract[] = [...state.selectedContracts.filter((contract: SelectedContract, index: number) => {
            //     return index !== payload.key;
            // })];
            return {
                ...state,
                selectedContracts: filteredContracts
            };

        case Actions.TERMSANDCONDITION:
            const terms: Term[] = payload.newTerms;

            if(state.recipientErrors[PageErrorType.termsError].isErrored && terms[0].checked) {
                return {
                    ...state,
                    terms: terms,
                    recipientErrors: {
                        ...state.recipientErrors,
                        [PageErrorType.termsError]: {...state.recipientErrors.termsError, isErrored: false}
                    }
                }
            } 

            return {
                ...state,
                terms: terms
            }
            

        default:
            return InitState;
    }
}